import { render, staticRenderFns } from "./plusPageTemp.vue?vue&type=template&id=158fc365&scoped=true&"
import script from "./plusPageTemp.vue?vue&type=script&lang=js&"
export * from "./plusPageTemp.vue?vue&type=script&lang=js&"
import style0 from "./plusPageTemp.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./plusPageTemp.vue?vue&type=style&index=1&id=158fc365&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158fc365",
  null
  
)

component.options.__file = "plusPageTemp.vue"
export default component.exports